import { useRef } from "react";
import Slider from "react-slick";
// If you use AOS globally, no need to import here. Just add data-aos attributes.

const TestimonialsThree = () => {
  const sliderRef = useRef(null);

  const settings = {
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false, // set true if you want auto-rotate
    autoplaySpeed: 4000,
    speed: 700,
    dots: false,
    pauseOnHover: true,
    arrows: false, // we use custom external arrows
    draggable: true,
    infinite: true,
    centerMode: true,
    centerPadding: "16px", // a little side padding looks better than 0
    responsive: [
      {
        breakpoint: 992, // tablets
        settings: {
          slidesToShow: 2,
          centerMode: false,
        },
      },
      {
        breakpoint: 576, // phones
        settings: {
          slidesToShow: 1,
          centerMode: false,
        },
      },
    ],
  };

  return (
    <section className="testimonials-three py-80 bg-main-25 position-relative z-1 overflow-hidden">
      <img
        src="assets/images/shapes/shape2.png"
        alt=""
        className="shape two animation-scalation"
      />
      <img
        src="assets/images/shapes/shape6.png"
        alt=""
        className="shape four animation-scalation"
      />
      <img
        src="assets/images/shapes/shape4.png"
        alt=""
        className="shape one animation-scalation"
      />

      <div className="container">
        <div className="row gy-4 align-items-center flex-wrap-reverse">
          <div className="col-xl-7">
            <Slider
              ref={sliderRef}
              {...settings}
              className="testimonials-three-slider"
            >
              <div className="testimonials-three-item bg-white p-24 rounded-12 box-shadow-md">
                <p className="text-neutral-500 my-20">
                  “The Best CBSE Schools in Bangalore – NPS Kudlu has an
                  exceptional faculty, innovative curriculum, inclusive
                  environment. State-of-the-art facilities and strong
                  parent-school partnership. Our child is flourishing
                  academically and emotionally. Highly recommended!”
                </p>
                <h4 className="mb-16 text-lg">Ms. Mary Christy</h4>
                <span className="text-neutral-500">Parent</span>
              </div>

              <div className="testimonials-three-item bg-white p-24 rounded-12 box-shadow-md">
                <p className="text-neutral-500 my-20">
                  “National Public School Kudlu is the Best CBSE school in
                  Bangalore. The best feature about this school is the admin.
                  They have very friendly and approachable teachers who know all
                  the students by their names and are always ready to help you
                  out if you need any advice or assistance.”
                </p>
                <h4 className="mb-16 text-lg">Kannan</h4>
                <span className="text-neutral-500">Parent</span>
              </div>

              <div className="testimonials-three-item bg-white p-24 rounded-12 box-shadow-md">
                <p className="text-neutral-500 my-20">
                  "As a parent, I couldn’t be happier with National Public
                  School Kudlu. The teachers are caring, approachable, and take
                  the time to understand every child’s strengths and challenges.
                  My child has grown not only academically but also in
                  confidence and character, thanks to the school’s holistic
                  approach."
                </p>
                <h4 className="mb-16 text-lg">Gautham</h4>
                <span className="text-neutral-500">Parent</span>
              </div>

              <div className="testimonials-three-item bg-white p-24 rounded-12 box-shadow-md">
                <p className="text-neutral-500 my-20">
                  "NPS Kudlu is the best school I could ask for! The teachers
                  are always ready to help, and they know us by our names, which
                  makes us feel special. I love how learning here is fun,
                  interactive, and exciting every day."
                </p>
                <h4 className="mb-16 text-lg">Milind</h4>
                <span className="text-neutral-500">Student</span>
              </div>
            </Slider>
          </div>

          <div className="col-xl-5 ps-xl-5">
            <div
              className="flex-align d-inline-flex gap-8 mb-16"
              data-aos="fade-down"
              data-aos-duration="700"
            >
              <h5 className="text-main-600 mb-0">Testimonials</h5>
            </div>

            <h2
              className="mb-24"
              data-aos="fade-left"
              data-aos-duration="800"
              data-aos-delay="100"
            >
              What Parents Say
            </h2>

            <p
              className="text-neutral-500 text-line-4"
              data-aos="fade-up"
              data-aos-duration="800"
              data-aos-delay="200"
            >
              Discover how our supportive environment, dedicated educators, and
              holistic learning approach help every child grow with confidence,
              curiosity, and character.
            </p>

            <div
              className="flex-align gap-16 mt-40"
              data-aos="fade-up"
              data-aos-delay="300"
            >
              <button
                type="button"
                id="testimonials-three-prev"
                onClick={() => sliderRef.current?.slickPrev()}
                className="slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1 w-48 h-48"
                aria-label="Previous testimonial"
              >
                <i className="ph ph-caret-left" />
              </button>
              <button
                type="button"
                id="testimonials-three-next"
                onClick={() => sliderRef.current?.slickNext()}
                className="slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1 w-48 h-48"
                aria-label="Next testimonial"
              >
                <i className="ph ph-caret-right" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialsThree;
